/**
 * Shared Google Maps JavaScript loader options.
 * Keep `libraries` as one stable array reference (useJsApiLoader performance note).
 */

export const MAPS_JS_LIBRARIES = Object.freeze(["places"]);

export function getMapsApiKeyFromEnv() {
  const raw = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  return typeof raw === "string" ? raw.trim() : "";
}

function mapsRegion() {
  const raw = process.env.REACT_APP_GOOGLE_MAPS_REGION;
  const r = typeof raw === "string" ? raw.trim().toUpperCase() : "";
  return r.length >= 2 ? r.slice(0, 2) : "IN";
}

function mapsLanguage() {
  if (typeof navigator === "undefined") return "en";
  const lang = (navigator.language || "en").replace(/_/g, "-");
  return lang.length <= 10 ? lang : lang.slice(0, 10);
}

export function createGoogleMapsJsLoaderProps(googleMapsApiKey) {
  return {
    id: "willplay-google-maps-script",
    googleMapsApiKey,
    version: "weekly",
    libraries: MAPS_JS_LIBRARIES,
    language: mapsLanguage(),
    region: mapsRegion()
  };
}
